if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//menu burger

	//open menu 
	document.querySelectorAll(".cta-menu-js").forEach( btn => {
		btn.addEventListener("click", (e)  =>{
			e.preventDefault();
			document.querySelector("#burger-menu").classList.add("open")
			document.querySelector("body").classList.add("no-scroll")
		})
	})

	//close menu
	document.querySelector(".burger-close-js").addEventListener("click" , (e) => {
		e.preventDefault();
		document.querySelector("#burger-menu").classList.remove("open")
		document.querySelector("body").classList.remove("no-scroll")
	})
	
	// cta text content
	document.querySelectorAll(".btn, .signup-btn").forEach( item => {
		let cta_inner = `<span class="icon"></span>${item.textContent}`
		item.innerHTML = cta_inner;
	})

	// slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

	// start slider default
	document.querySelectorAll('.swiper-js').forEach((element,i) => {
		
		let swiperConfig = element.dataset.swipper ? JSON.parse(element.dataset.swipper): defaulsettings;
		
		element.setAttribute(`data-swiper-${i}`,"")
		
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
		
	});

	// start accommodations slider

	let accommodation_one = new Swiper(".acomo-one-js", {
		speed: 700,
		allowTouchMove:false,
		controller: {
			control: accommodation_two,
		}
	});
	
	let accommodation_two = new Swiper(".acomo-two-js", {
		speed: 700,
		pagination: {
			el: ".rooms-typetwo__dots",
			clickable: true,
		},
		controller: {
			control: accommodation_one,
		}
	});


// experience funcionality 
const experienceItems = document.querySelectorAll('.experience-text-js .experience__item');
const experienceImages = document.querySelectorAll('.experience-img-js img');
let currentIndex = 0;

function setActiveClass(index) {
  for (let i = 0; i < experienceItems.length; i++) {
    experienceItems[i].classList.remove('active');
  }
  experienceItems[index].classList.add('active');

  for (let i = 0; i < experienceImages.length; i++) {
    const img = experienceImages[i];
    img.classList.remove('active');
    if (experienceItems[index].dataset.expeinfo === img.dataset.expeimg) {
      img.classList.add('active');
    }
  }
}

function showNextExperience() {
  currentIndex = (currentIndex + 1) % experienceItems.length;
  setActiveClass(currentIndex);
}

function initExperience() {
  experienceItems.forEach((item, index) => {
    item.addEventListener('mouseover', (event) => {
      setActiveClass(index);
      clearInterval(intervalId);
    });
    if (index === currentIndex) {
      item.classList.add('active');
      setActiveClass(index);
    }
  });

  const intervalId = setInterval(showNextExperience, 3000);
}

if(document.querySelector(".experience") != null && window.innerWidth > 640){
	initExperience();
}
})()
